import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function useTitle() {
  const location = useLocation();

  useEffect(() => {
    const baseTitle = "Gymnaze";
    let title = baseTitle;

    switch (location.pathname) {
      case "/":
        title = "Welcome | " + baseTitle;
        break;
      case "/dashboard":
        title = "My Dashboard | " + baseTitle;
        break;
      case "/dashboard/quiz":
        title = "Quiz | " + baseTitle;
        break;
      case "/dashboard/gscore-quiz":
        title = "G-Score Quiz | " + baseTitle;
        break;
      case "/admin":
        title = "Admin Panel | " + baseTitle;
        break;
      default:
        title = baseTitle;
    }

    document.title = title;
  }, [location]);
}

export default useTitle;